import React, { useState } from "react";
import "./listAccordion.css";
import {
  ListGroup,
  ListGroupItem,
  ListGroupItemHeading,
  ListGroupItemText,
  Collapse,
  Button,
  CardBody,
  Card,
} from "reactstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faChevronCircleRight,
  faChevronCircleDown,
} from "@fortawesome/free-solid-svg-icons";

const ListAccordion = ({ item }) => {
  const [isOpen, setIsOpen] = useState(false);
  const toggle = () => setIsOpen(!isOpen);

  return (    
    <ListGroup id="accordion">
      <ListGroupItem className="listAccordion">
        <ListGroupItemHeading className="d-flex align-items-center justify-content-between mb-0">
          <div className="title-heading-list font24">{item.title}</div>
          <Button color="light" size="lg" className="btn-accordion" onClick={toggle}>
            {isOpen ? (
              <FontAwesomeIcon icon={faChevronCircleDown} size="lg" />
            ) : (
              <FontAwesomeIcon icon={faChevronCircleRight} size="lg" />
            )}
          </Button>
        </ListGroupItemHeading>
        <ListGroupItemText>
            {item.subtitle}
          <Collapse isOpen={isOpen}>
            <Card className="card-content-acordeon text-dark mt-4 font18">
              <CardBody className="font14">
                <p>{item.description}</p>
                {item.baseUrl}
              </CardBody>
            </Card>
          </Collapse>
        </ListGroupItemText>
      </ListGroupItem>
    </ListGroup>
  );
};

export default ListAccordion;
